import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { RecoilRoot, useRecoilValue } from 'recoil';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { LinearProgress, ThemeProvider } from '@mui/material';
import { lightTheme, darkTheme } from './theme';
import App from './app/App';
import { themeState } from './api';
import { ThemeMode } from './abelcommon';
import RecoilNexus from 'recoil-nexus';
import './i18n';

const queryClient = new QueryClient();

const root = createRoot(document.getElementById('root') as HTMLElement);
const AppWrapper = () => {
  const themeMode = useRecoilValue(themeState);

  return (
    <ThemeProvider theme={themeMode === ThemeMode.Dark ? darkTheme : lightTheme}>
      <App />
    </ThemeProvider>
  );
};

root.render(
  <React.StrictMode>
    <Suspense fallback={<LinearProgress />}>
      <RecoilRoot>
        <RecoilNexus />
        <QueryClientProvider client={queryClient}>
          <ReactQueryDevtools initialIsOpen={false} />
          <AppWrapper />
        </QueryClientProvider>
      </RecoilRoot>
    </Suspense>
  </React.StrictMode>
);
